import React from "react";

import "./AddressCard.scss";
import Card from "../Card";
import Skeleton from "../Skeleton/Skeleton";

const AddressCard = ({ contact, loading }) => {
  if (loading) {
    return (
      <Card
        title="Address"
        body={
          <div className="address-card">
            <div className="address-card__strapline">
              <Skeleton variant="text" width="75%" />
            </div>
            <div className="address-card__strapline">
              <Skeleton variant="text" width="65%" />
            </div>
            <div className="address-card__strapline">
              <Skeleton variant="text" width="50%" />
            </div>
            <div className="address-card__strapline">
              <Skeleton variant="text" width="60%" />
            </div>
          </div>
        }
      />
    );
  }

  return (
    <Card
      title="Address"
      body={
        <div className="address-card">
          {contact.address !== null && contact.address.addressLine1 ? (
            <>
              {" "}
              <div className="address-card__strapline">
                {contact.address.addressLine1}
              </div>
              <div className="address-card__strapline">
                {contact.address.addressLine2} {contact.address.postalCode}
              </div>
              <div className="address-card__strapline">
                {contact.address.city}
              </div>
              <div className="address-card__strapline">
                {contact.address.province} {contact.address.postalCode}
              </div>{" "}
            </>
          ) : (
            <div className="address-card__strapline">
              {"-"} {"-"} {"-"} {"-"}
            </div>
          )}
        </div>
      }
    />
  );
};

export default AddressCard;
